import { jsx as t } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import * as o from "@radix-ui/react-switch";
import { twMerge as i } from "tailwind-merge";
const e = d((s, a) => {
  const { className: c = "", size: r = "md", ...n } = s;
  return /* @__PURE__ */ t(
    o.Root,
    {
      ...n,
      ref: a,
      className: i(
        r === "sm" && "h-4 w-7",
        r === "md" && "h-5 w-9",
        r === "lg" && "h-7 w-12",
        "focus-visible:ring-ring focus-visible:ring-offset-background radix-state-checked:bg-blue-500 radix-state-unchecked:bg-gray-300 radix-disabled:cursor-not-allowed radix-disabled:opacity-50 group relative flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
        c
      ),
      children: /* @__PURE__ */ t(
        o.Thumb,
        {
          className: i(
            r === "sm" && "group-radix-state-checked:translate-x-3 size-3",
            r === "md" && "group-radix-state-checked:translate-x-4 size-4",
            r === "lg" && "group-radix-state-checked:translate-x-5 size-6",
            "absolute bottom-0 left-0 top-0 rounded-full bg-white shadow-lg ring-0 transition-transform"
          )
        }
      )
    }
  );
});
e.displayName = "Switch";
const f = e, g = e;
export {
  g as Root,
  e as Switch,
  f as SwitchRoot
};
